import {axiosInstance} from "@/api/modules/si-api-instance";

const getTopWords = (process_id, type,from,to) => {
    return axiosInstance.get('getTopWords', {
        params:{
            process_id: process_id,
            type: type,
            date_from: from,
            date_to: to
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getTopHashtags = (process_id, type) => {
    return axiosInstance.get('getTopHashtags', {
        params: {
            process_id: process_id,
            type: type
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}


const getTotalsHashsTweetsAccounts = (process_id, from,to,type) => {
    return axiosInstance.get(process.env.VUE_APP_API+'getTotalsHashsTweetsAccounts', {
        params: {
            process_id: process_id,
            type: type,
            date_from: from,
            date_to: to
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getInfluencersInfoRetFol = (process_id) => {
    return axiosInstance.get(process.env.VUE_APP_API+'getInfluencersInfoRetFol', {
        params: {
            process_id: process_id
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getInfluencersInfoRetFolSentiment = (process_id,from,to) => {
    return axiosInstance.get(process.env.VUE_APP_API+'getInfluencersInfoRetFolSentiment', {
        params: {
            process_id: process_id,
            date_from: from,
            date_to: to
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getOrigenesByCountry = (process_id, type) => {
    return axiosInstance.get('getOrigenesByCountry', {
        params: {
            process_id: process_id,
            type: type
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getOrigenes = (process_id, type) => {
    return axiosInstance.get('getOrigenesByCity', {
        params: {
            process_id: process_id,
            type: type
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getTotalSentiments = (process_id,from,to, type) => {
    return axiosInstance.get('getTotalSentiments', {
        params: {
            process_id: process_id,
            type: type,
            date_from: from,
            date_to: to
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getTotalSentimentsRetweets = (process_id,from,to, type) => {
    return axiosInstance.get('getTotalSentimentsRetweets', {
        params: {
            process_id: process_id,
            type: type,
            date_from: from,
            date_to: to
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getDatesEvolution = (process_id) => {
    return axiosInstance.get('getDatesEvolution', {
        params: {
            process_id: process_id
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getDatesEvolutionSentiment = (process_id,from,to) => {
    return axiosInstance.get('getDatesEvolutionSentiment', {
        params: {
            process_id: process_id,
            date_from: from,
            date_to: to
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getDatesEvolutionRetweet = (process_id,from,to) => {
    return axiosInstance.get('getDatesEvolutionRetweet', {
        params: {
            process_id: process_id,
            date_from: from,
            date_to: to
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getTop10Tweets = (process_id, type) => {
    return axiosInstance.get('getTop10Tweets', {
        params: {
            process_id: process_id,
            type: type
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getTop3Tweets = (process_id, type,from,to) => {
    return axiosInstance.get('getTop3Tweets', {
        params: {
            process_id: process_id,
            type: type,
            date_from: from,
            date_to: to
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getWorldData = () => {
    return axiosInstance.get('getWorldData')
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

export default {
    getTotalsHashsTweetsAccounts,
    getTopWords,
    getTopHashtags,
    getInfluencersInfoRetFol,
    getInfluencersInfoRetFolSentiment,
    getOrigenes,
    getOrigenesByCountry,
    getTotalSentiments,
    getTotalSentimentsRetweets,
    getDatesEvolution,
    getDatesEvolutionSentiment,
    getDatesEvolutionRetweet,
    getTop10Tweets,
    getTop3Tweets,
    getWorldData
};
